import { mapDTO } from '@twistezo/ts-dto-mapper'

import { Schema } from '../../../forms/GeneralPageForm'
import { Variables } from './types'

type From = Schema
type To = Variables

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((schema: From): To => {
    const { enabled, id, pubId } = schema

    return {
      enabled: id ? enabled : false,
      pubId,
    }
  })
